import { SettingValues } from '@linearb/linjs-common';
import { getProjectsToAddToPmImportStrategyByBoardsIds } from 'common/services/pm.service';
import _ from 'lodash';
import { METHOD_NAMES } from './consts';
import {
  formatBoardsToProjectTeamAreas,
  selectedFiltersToUpdateConfigurationBodyConverter,
  shouldSaveToPmImportStrategy
} from './utils';
import { FILTER_TYPES, resolveFilterValue } from 'common/constants/filters';
import { unionEntitiesWithPMImportSettings } from 'components/FilterMenus/FilterMenus.service';

export const configurationToSelectedMethod = ({ cadence = {} }) => {
  return _.get(cadence, 'type', null);
};
const ISSUES_COUNT_LAST_X_DAYS = 14;

export const handleSave = async ({
  selectedMethod,
  selectedFilters,
  onSaveClick,
  projectName,
  curProjectName,
  upsertConfiguration,
  nameValidator,
  isFormValid,
  isSkipProjectsBoardSelectionFFEnabled,
  issuesCount = {},
  includeIterations,
  excludeIterations,
  pmSensor = {},
  allBoardsByProviderIds,
  getSettingOrDefinitionValue,
  updateSetting,
  entitiesDeviation,
  entitiesLimit
}) => {
  const pmImportSettings =
    getSettingOrDefinitionValue({
      name: SettingValues.PM_IMPORT_STRATEGY
    }) || {};
  const selectedMethodDays =
    METHOD_NAMES[
      Object.keys(METHOD_NAMES).find(
        key => METHOD_NAMES[key].type === selectedMethod
      )
    ].days;

  const requestBody = {
    ...selectedFiltersToUpdateConfigurationBodyConverter({
      selectedFilters,
      selectedMethod,
      selectedMethodDays,
      includeIterations,
      excludeIterations
    }),
    meta_data: {
      issuesCount: {
        total: _.get(issuesCount, 'total'),
        filters: selectedFilters,
        periodDays: ISSUES_COUNT_LAST_X_DAYS,
        timestamp: new Date(),
        extra: ''
      }
    }
  };

  if (nameValidator.isValid && isFormValid) {
    const boardsProviderIds =
      selectedFilters[FILTER_TYPES.BOARD]?.map(({ id }) => id) || [];

    const projectsToPmImportStrategy =
      getProjectsToAddToPmImportStrategyByBoardsIds(
        boardsProviderIds,
        pmImportSettings?.projects,
        allBoardsByProviderIds
      );

    const mergedEpics = unionEntitiesWithPMImportSettings(
      pmImportSettings.epics,
      selectedFilters[FILTER_TYPES.EPIC],
      FILTER_TYPES.EPIC
    );

    const result = await upsertConfiguration({
      ...requestBody,
      projectName: curProjectName !== projectName ? curProjectName : projectName
    });
    onSaveClick(result);
    const pmImportStrategyPayload = {
      ...pmImportSettings,
      projects: projectsToPmImportStrategy,
      epics: mergedEpics
    };

    if (
      shouldSaveToPmImportStrategy(
        projectsToPmImportStrategy,
        mergedEpics,
        pmImportSettings
      )
    ) {
      // if this condition is true, it means that one or more projects or epics need to be added
      updateSetting(SettingValues.PM_IMPORT_STRATEGY, pmImportStrategyPayload);
    }
  }
};

export const resolveFilterIdAndTitle = values => {
  return values.map(({ provider_id, name, entity_type }) => ({
    id: provider_id,
    title: name,
    ...(entity_type && { entity_type })
  }));
};

export const configurationToSelectedFilters = ({
  boards = [],
  epics = [],
  projects = [],
  teams = [],
  labels = [],
  fix_versions: fixVersions = [],
  fields = {},
  parent_issues: parentIssues = []
}) => {
  const isBoardsProjectTeamAreas = !!boards?.[0]?.project;
  return {
    ...(isBoardsProjectTeamAreas
      ? {
          [FILTER_TYPES.AZURE_BOARDS_PROJECT_TEAM_AREAS]:
            formatBoardsToProjectTeamAreas(boards)
        }
      : { board: resolveFilterIdAndTitle(boards) }),
    label: resolveFilterValue(labels),
    fixVersion: resolveFilterValue(fixVersions),
    epic: resolveFilterValue(epics),
    projects: resolveFilterIdAndTitle(projects),
    teams: resolveFilterIdAndTitle(teams),
    [FILTER_TYPES.DYNAMIC_ISSUES]: resolveFilterIdAndTitle(
      parentIssues.map(issue => ({ ...issue, entity_type: issue.type }))
    ),
    ...Object.keys(fields).reduce((acc, curKey) => {
      const currentValue = fields[curKey];
      acc[curKey] = resolveFilterValue(
        _.isArray(currentValue) ? currentValue : [currentValue]
      );
      return acc;
    }, {})
  };
};

export const checkForComponentsIncludeInConfiguration = configuration => {
  if (!configuration.components_include) {
    return configuration;
  }
  const values = configuration.components_include;
  return {
    ...configuration,
    fields: {
      ...configuration.fields,
      components: values
    }
  };
};
